export default __webpack_public_path__ + "static/media/local_cafefree_breakfast.1f0e1ca7.svg";